<template>
  <div
    v-if="!inIframe"
    class="breadcrumb-box"
  >
    <Breadcrumb>
      <BreadcrumbItem
        v-for="(item,index) in breadcrumbList"
        :key="index"
        :to="item.to"
      >
        {{ item.text }}
      </BreadcrumbItem>
    </Breadcrumb>
    <!-- <Button
        class="go-back"
        @click="$router.push('/app/market/index')"
      >
        返回应用中心
      </Button> -->
  </div>
</template>

<script>
import {inIframe} from '@/common/createMicroApp/utils';
export default {
  components: {},
  props: {
    breadcrumbList: {
      type: Array,
      default: ()=>[],
    },
  },
  data() {
    return {
      inIframe,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang='less' scoped>
.breadcrumb-box {
  // background-color: #fff;
  padding-bottom: 10px;
  position: relative;
  .go-back {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
</style>
